import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const UPDATE_VERSION_STMT_REQUEST = 'UPDATE_VERSION_STMT_REQUEST';
export const UPDATE_VERSION_STMT_SUCCESS = 'UPDATE_VERSION_STMT_SUCCESS';
export const UPDATE_VERSION_STMT_FAILURE = 'UPDATE_VERSION_STMT_FAILURE';

function request() {
  return {
    type: UPDATE_VERSION_STMT_REQUEST
  };
}

function receive(versionWindow) {
  return {
    type: UPDATE_VERSION_STMT_SUCCESS,
    effectiveDate: versionWindow.effectiveFromDate,
    effectiveToDate: versionWindow.effectiveToDate,
    index: versionWindow.index
  };
}

function reject() {
  return {
    type: UPDATE_VERSION_STMT_FAILURE
  };
}

export function updateVersion(accountId, versionWindow) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .updateStatementEffectiveDates(accountId, versionWindow)
      .then((response) => {
        if (!response.data) {
          toastr.success('Update Failed', 'There was a problem publishing the statement');
        } else {
          dispatch(receive(versionWindow));
          toastr.success('Update Successful', `Statement Version ${ response.data.version } ${ response.data.isRepublish ? 're' : '' }published`);
        }
      })
      .catch(error => dispatch(handleException(error, () => dispatch(reject(accountId)), true)));

    return promise();
  };
}
